<template>
    <!-- About Our Company -->
    <section class="about-our-company">
        <div class="our-company-img">
            <img src="@/assets/img/bg/wave.png" alt="image" class="img-fluid">
        </div>
        <div class="container">
            <div class="section-heading section-heading-six">
                <div class="row">
                    <div class="col-md-9 col-12 aos" data-aos="fade-up">
                        <div class="reason-six">
                            <img src="@/assets/img/icons/window-cleaner-detergent-svgrepo-com.svg" alt="image" class="rounded-circle">
                            <p>BEST CLEANING SERVICE</p>
                        </div>
                        <h2><span>About </span>Our Company</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-12">
                    <div class="our-company-six">
                        <p>
                            A service marketplace can be a powerful tool for entrepreneurs looking to access 
                            specialized skills and support. By following these tips, you can navigate the marketplace 
                            effectively, find the right 
                            service providers, and enhance your business operations. Ready to get started? 
                        </p>
                    </div>
                    <div class="aboutus-companyimg">
                        <div class="our-company-overlay-img d-none d-lg-block">
                            <img src="@/assets/img/bg/buttom-wave.png" alt="img">
                        </div>
                        <a href="javascript:void(0);">
                            <img src="@/assets/img/services/service-84.png" alt="img">
                        </a>
                        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#video">
                            <div class="playicon">
                                <span>
                                    <i class="feather-play"></i>
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="our-company-ryt d-none d-lg-block">
                        <div class="bg-overlay-img d-none d-lg-block">
                            <img src="@/assets/img/bg/our-company-bg.png" alt="img" class="img-fluid">
                        </div>
                        <div class="our-company-bg">
                            <img src="@/assets/img/bg/our-company-six.png" alt="image" class="img-fluid">
                        </div>
                        <div class="our-company-first-content">
                            <router-link to="/pages/contact-us" class="me-2">
                                <i class="ti ti-device-mobile-filled"></i>
                            </router-link>
                            <div class="company-top-content">
                                <p>Call us Today!</p>
                                <h3 class="text-dark">+012 345678</h3>
                            </div>
                            
                        </div>
                        <div class="our-company-two-content">
                            <div class="company-two-top-content">
                                <img src="@/assets/img/icons/trophy-svgrepo-com.svg" alt="image" class="me-2">
                                <h4 class="text-dark">12+</h4>
                                
                            </div>
                            <p>Years Experience</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- /About Our Company -->

    <!-- Get Satisfied with the services Explore All -->
    <section class="satisfied-service-section">
        <div class="container">
            <div class="section-heading section-heading-six">
                <div class="row align-items-end">
                    <div class="col-md-9 aos" data-aos="fade-up">
                        <div class="reason-six">
                            <img src="@/assets/img/icons/cleaning-mop.svg" alt="image" class="rounded-circle">
                            <p>AFFORDABLE & RELIABLE</p>
                        </div>
                        <h2>Get Satisfied with the <span>services</span></h2>
                    </div>
                    <div class="col-md-3 aos" data-aos="fade-up">
                        <router-link to="/details/service-details" class="afford-btn">Explore All</router-link>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/sofa.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Upholstery Cleaning</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/apporment-cleaning.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Apartment Cleaning</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/covid-cleaning.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Covid Clean-Up</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/office-cleaning.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Office Cleaning</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/move-in.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Move In/ Out Cleaning</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/commercial-cleaning.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Commercial Cleaning</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/window-cleaning.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Window Cleaning</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12 d-flex">
                    <div class="get-service-main w-100">
                        <span>
                            <img src="@/assets/img/icons/carpet-cleaning.svg" alt="image">
                        </span>
                        <router-link to="/details/service-details">
                            <h5>Carpet Cleaning</h5>
                        </router-link>
                        <div class="get-service-btn">
                            <router-link to="/details/service-details">
                                View More <i class="ms-2 feather-chevron-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <!-- /Get Satisfied with the services Explore All -->
</template>